<template>
  <div>
    <ActionDropdown v-if="campaign?.id" :circle="circle" @command="handleCommand">
      <el-dropdown-item
        v-if="ctaEditPremission && ($canAccess(['agency', 'agency-employee', 'employee']) || $isTopBrandAdmin()) && !$is_PM"
        icon="el-icon-edit"
        command="edit"
        >Edit</el-dropdown-item
      >
      <el-dropdown-item v-if="isHeader && ctaEditCPM_Premission && $is_PM" icon="el-icon-edit" command="edit-cpm"
        >Edit CPM</el-dropdown-item
      >
      <el-dropdown-item
        v-if="!campaign.is_draft && ($canAccess(['agency', 'agency-employee', 'employee']) || $isTopBrandAdmin()) && !$is_PM && !$is_GD"
        icon="el-icon-copy-document"
        command="duplicate"
        >Duplicate</el-dropdown-item
      >
      <el-dropdown-item
        v-if="ctaDeletePremission && ($canAccess(['agency', 'agency-employee', 'employee']) || $isTopBrandAdmin()) && !$is_PM"
        icon="el-icon-delete"
        command="delete"
        >Delete</el-dropdown-item
      >
    </ActionDropdown>
  </div>
</template>
<script>
import ActionDropdown from '@/components/social-products/social-boost/parts/ActionDropdown.vue'
import ModalDeleteCampaign from '@/components/social-products/social-boost/modal/DeleteCampaign.vue'
import EditCpm from '@/components/social-products/social-boost/modal/EditCpm.vue'

export default {
  name: 'TableAction',
  components: { ActionDropdown },
  props: {
    campaign: {
      type: [Object, Boolean],
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    circle: {
      type: Boolean,
      default: false,
    },
    redirectTo: {
      type: String,
      default: null,
    },
    isHeader: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    flight() {
      return this.campaign?.flights?.length > 0 ? this.campaign.flights[0] : false
    },
    ctaEditPremission() {
      if (!this.campaign.is_simple) return true
      return this.flight ? this.$SBCampaignStatusAccess(['new', 'revision'], this.flight.status) && this.campaign.is_owner : true
    },
    ctaEditCPM_Premission() {
      return this.campaign?.can_edit_cpm
    },
    ctaDeletePremission() {
      if (!this.campaign.is_simple) {
        let canDelete = this.campaign.is_owner
        this.campaign?.flights?.forEach((flight) => {
          if (!this.$SBCampaignStatusAccess(['new', 'revision'], flight.status)) {
            canDelete = false
          }
        })
        return canDelete
      }
      return this.flight ? this.$SBCampaignStatusAccess(['new', 'revision'], this.flight.status) : true
    },
  },
  methods: {
    reload(storeModule = null, params) {
      if (!storeModule) {
        return
      }
      this.$store.dispatch(storeModule, params)
    },
    handleCommand(command) {
      switch (command) {
        case 'edit':
          this.$router.push({
            name: 'social-boost-edit',
            params: { id: this.campaign.id, type: this.campaign.is_simple ? 'simple' : 'flights' },
          })
          break
        case 'delete':
          this.$Modal.init(
            {
              propsData: {
                component: ModalDeleteCampaign,
                meta: { campaign: this.campaign, index: this.index, redirectTo: this.redirectTo },
                size: '480px',
              },
              callback(payload) {
                if (payload.event === 'modal:close') {
                }
              },
            },
            this
          )
          break
        case 'edit-cpm':
          this.$Modal.init(
            {
              propsData: {
                component: EditCpm,
                meta: { campaign: this.campaign },
                size: '480px',
              },
              callback(payload) {
                if (payload.event === 'modal:close') {
                  console.log('Edit CPM modal closed')
                }
              },
            },
            this
          )
          break
        case 'duplicate':
          this.$store.dispatch('socialBoostCampaign/duplicateCampaign', {
            campaignId: this.campaign.id,
          })
          break
        default:
          break
      }
    },
  },
}
</script>
